import React from "react";
import { useToast } from "../../hooks/use-toast";
import { X, CheckCircle, AlertCircle, AlertTriangle, Info } from "lucide-react";

const Toast = ({ toast, onDismiss }) => {
  // Auto dismiss after delay
  React.useEffect(() => {
    const timer = setTimeout(() => {
      handleDismiss();
    }, toast.duration || 2000);

    return () => clearTimeout(timer);
  }, [toast.id]);

  const handleDismiss = () => {
    console.log('Dismissing toast:', toast.id);
    // Force remove the toast element
    const toastElement = document.querySelector(`[data-toast-id="${toast.id}"]`);
    if (toastElement) {
      toastElement.style.opacity = '0';
      toastElement.style.transform = 'translateX(100%)';
      setTimeout(() => {
        toastElement.remove();
      }, 200);
    }
    onDismiss(toast.id);
  };

  const getIcon = () => {
    switch (toast.variant) {
      case "destructive":
        return <AlertTriangle className="w-5 h-5" />;
      case "success":
        return <CheckCircle className="w-5 h-5" />;
      case "warning":
        return <AlertCircle className="w-5 h-5" />;
      default:
        return <Info className="w-5 h-5" />;
    }
  };

  const getStyles = () => {
    switch (toast.variant) {
      case "destructive":
        return "bg-red-50 border-red-200 text-red-800";
      case "success":
        return "bg-green-50 border-green-200 text-green-800";
      case "warning":
        return "bg-yellow-50 border-yellow-200 text-yellow-800";
      default:
        return "bg-blue-50 border-blue-200 text-blue-800";
    }
  };

  return (
    <div 
      data-toast-id={toast.id}
      className={`relative flex items-start p-4 pr-8 bg-white border rounded-lg shadow-lg transition-all duration-300 min-w-[300px] ${getStyles()}`}
    >
      <div className="flex-shrink-0 mr-3 mt-0.5">
        {getIcon()}
      </div>
      <div className="flex-1 min-w-0">
        {toast.title && (
          <div className="font-semibold text-sm mb-1 pr-2">{toast.title}</div>
        )}
        {toast.description && (
          <div className="text-sm opacity-90 pr-2">{toast.description}</div>
        )}
      </div>
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 opacity-70 hover:opacity-100 transition-opacity cursor-pointer z-[60] pointer-events-auto bg-white rounded-full p-1 hover:bg-gray-100 shadow-sm border border-gray-200"
        aria-label="Chiudi notifica"
        type="button"
      >
        <X className="w-3 h-3 text-gray-600" />
      </button>
    </div>
  );
};

export const Toaster = () => {
  const { toasts, dismiss } = useToast();

  return (
    <div className="fixed top-4 right-4 z-[9999] space-y-3 max-w-md pointer-events-none">
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast toast={toast} onDismiss={dismiss} />
        </div>
      ))}
    </div>
  );
};